import { useCallback } from 'react';
import { GroupUser, IRoleUser } from '@shared/interfaces';
import { UsersManipulator } from '../UsersManipulator';

interface IAddUserProps {
  data: IRoleUser[];
  onChange(user: IRoleUser): void;
  onDelete(usersToDelete: IRoleUser[]): void;
}

export const AddUsers = ({ data, onChange, onDelete }: IAddUserProps) => {
  const onSelectUser = (user?: GroupUser) => {
    if (user) {
      onChange({
        isExcluded: false,
        isIncluded: true,
        userId: user.userId,
        userName: user.userName,
      });
    }
  };

  const onDeleteUser = useCallback(
    (userId: string) => {
      onDelete(data.filter((user) => user.userId !== userId));
    },
    [data]
  );

  return (
    <UsersManipulator
      title="Add Users Individually"
      data={data}
      onSelectUser={onSelectUser}
      onDeleteUser={onDeleteUser}
    />
  );
};
